jQuery(document).ready( function($) {
  
  $('.testimonial-owl').slick({
    centerMode: true,
    autoplay: true,
    centerPadding: '60px',
    slidesToShow: 3,
    infinite: true,
    arrows: false,
    adaptiveHeight:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          adaptiveHeight:true
        }
      }
    ]
  });

  $('.home-product-slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    infinite: true,
    arrows: false,
    adaptiveHeight:true,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          adaptiveHeight:true
        }
      }
    ]
  });

  $('.product-single-slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 1,
    infinite: true,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.logo-slider').slick({
    centerMode: true,
    autoplay: true,
    centerPadding: '60px',
    slidesToShow: 5,
    infinite: true,
    arrows: false,
    adaptiveHeight:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2,
          adaptiveHeight:true
        }
      },
      {
        breakpoint: 450,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
          adaptiveHeight:true
        }
      }
    ]
  });
  
  // const mediaQuery = window.matchMedia('(max-width: 768px)')
  // if (mediaQuery.matches) {
    $('.home-blog-section .article-list.article-layout--columns.article-layout--one-row').slick({
      centerMode: false,
      centerPadding: '60px',
      slidesToShow: 3,
       autoplay: true,
      infinite: true,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
             autoplay: true,
            arrows: false,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
    });
  // }

  $(".theme-product-reviews").click(function() {
      // Scroll to the section with ID 'targetSection'
      $('html, body').animate({
          scrollTop: $(".shopify-section.section-apps").offset().top
      }, 1000); // 1000 milliseconds = 1 second scroll duration
  });

  $("variant-picker .option-selector__btns label").click(function() {
    var thisObj = $(this);
    var variantName = thisObj.attr('data-swatch');
    thisObj.parents('variant-picker').find('legend span').html(variantName);
  });
});